let Bio5Hats = [
	18971, 18972, 18973, 18974, 18975, 18976, 18977, 18978, 18979, 18980, 18981,
	18982, 18983, 18984,
]
let IllusionArmors = [15376, 15377]
let IllusionWings = [20933, 20934]
let IllusionLegs = [22196, 22197]
let IllusionLeftAccessories = [32207, 32209]
let IllusionRightAccessories = [32208, 32210]

export function isEnchantable(itemID) {
	if (Bio5Hats.includes(itemID)) return true
	if (IllusionArmors.includes(itemID)) return true
	if (IllusionWings.includes(itemID)) return true
	if (IllusionLegs.includes(itemID)) return true
	if (IllusionLeftAccessories.includes(itemID)) return true
	if (IllusionRightAccessories.includes(itemID)) return true

	return false
}

export function isEnchantSlot(itemID, Slot) {
	if (Slot === 3 || Slot === 2 || Slot === 1) {
		return isEnchantable(itemID)
	}
	return false
}

export function getEnchant(itemID, slot) {
	if (Bio5Hats.includes(itemID)) {
		if (slot === 2 || slot === 3)
			return [
				// Strength1
				4700, 4701, 4702, 4703, 4704,
				// Inteligence1
				4710, 4711, 4712, 4713, 4714,
				// Dexterity1
				4720, 4721, 4722, 4723, 4724,
				// Agility1
				4730, 4731, 4732, 4733, 4734,
				// Vitality1
				4740, 4741, 4742, 4743, 4744,
				// Luck1
				4750, 4751, 4752, 4753, 4754,
			]
		if (slot === 1)
			return [
				// Strength4
				4703, 4704,
				// Inteligence4
				4713, 4714,
				// Dexterity4
				4723, 4724,
				// Agility4
				4733, 4734,
				// Vitality4
				4743, 4744,
				// Luck4
				4753, 4754,
				// Ambition1Lv (Mettle)
				29061, 29062, 29063, 29064, 29065, 29066, 29067, 29068, 29069,
				29070,
				// Tab1Lv (Magic Essence)
				29071, 29072, 29073, 29074, 29075, 29076, 29077, 29078, 29079,
				29080,
				// Expect1Lv (Acute)
				29081, 29082, 29083, 29084, 29085, 29086, 29087, 29088, 29089,
				29090,
				// ArchLine1Lv (Master Archer)
				29091, 29092, 29093, 29094, 29095, 29096, 29097, 29098, 29099,
				29100,
				// Steel1Lv (Adamantine)
				29101, 29102, 29103, 29104, 29105, 29106, 29107, 29108, 29109,
				29110,
				// Mercy1Lv (Affection)
				29111, 29112, 29113, 29114, 29115, 29116, 29117, 29118, 29119,
				29120,
			]
	}
	if (IllusionArmors.includes(itemID))
		return [29527, 29528, 29534, 29535, 29536, 29540]
	if (IllusionWings.includes(itemID))
		return [29527, 29528, 29537, 29538, 29539, 29542]
	if (IllusionLegs.includes(itemID)) {
		if (slot === 3)
			return [
				29527, 29528, 29531, 29530, 29533, 29541, 29547, 29548, 29549,
				29550, 29551, 29552,
			]
		if (slot === 1 || slot === 2)
			return [29527, 29528, 29531, 29530, 29533, 29541]
	}
	if (IllusionLeftAccessories.includes(itemID))
		return [
			4742, 4752, 4712, 4722, 4826, 4881, 4866, 4836, 29532, 29544, 29546,
		]
	if (IllusionRightAccessories.includes(itemID))
		return [
			4742, 4752, 4702, 4732, 4826, 4881, 4866, 4836, 29529, 25696, 25698,
		]
	return -1
}
